import { getActionNames } from "../lib/create-action";
import ActionManager from "./base";
import fetch from "cross-fetch";
import getAPIPrefix from "../lib/api_prefix";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

const defaultArgs = {
  method: "get",
  auth: false,
};

class DefaultActionManager extends ActionManager {
  constructor({ actionName, ...args }) {
    super({ ...defaultArgs, ...args });
    if (!actionName) {
      throw Error("actionName must be provided");
    }

    if (!this.args.route) {
      throw Error("route must be provided");
    }
    this.actionNames = getActionNames(actionName);
  }

  defaultPreCallActionCreator = () => {
    return {
      type: this.actionNames.started,
      data: this.args.actionData,
      requestID: this.args.requestID,
      body: this.args.body,
    };
  };

  defaultSuccessActionCreator = json => {
    return {
      type: this.actionNames.success,
      payload: {
        resp: json,
        body: this.args.body,
      },
      data: this.args.actionData,
      requestID: this.args.requestID,
    };
  };

  default400ActionCreator = validationErrors => {
    return {
      type: this.actionNames.failureBadRequest,
      payload: {
        error: this.defaultErrorMessage(),
        validationErrors: validationErrors,
        body: this.args.body,
      },
      requestID: this.args.requestID,
    };
  };

  defaultErrorActionCreator = () => errorMessage => {
    return this.defaultFailureActionCreator(
      this.actionNames.failure,
      errorMessage || this.defaultErrorMessage()
    );
  };

  defaultFailureActionCreator = (actionName, response) => {
    return {
      requestID: this.args.requestID,
      type: actionName,
      payload: {
        error: response.errorMessage || this.defaultErrorMessage(),
        status: response.status,
      },
    };
  };

  preCall(dispatch) {
    dispatch(this.defaultPreCallActionCreator());
  }

  getBody = getState => {
    if (this.args.useRawInput) {
      return this.args.body;
    }

    if (typeof this.args.body === "function") {
      return JSON.stringify(this.args.body(getState()));
    }

    return JSON.stringify(this.args.body);
  };

  execute(dispatch, getState) {
    return fetch(`${getAPIPrefix()}${this.args.route}`, {
      body: this.getBody(getState),
      method: this.args.method,
      headers: {
        Authorization: this.args.auth && `Bearer ${get(getState(), "user.user.authToken", "")}`,
        ...this.args.headers,
      },
    });
  }

  responseOK(dispatch, json = {}) {
    const successMessage = get(this.args, "successMessage");
    if (!isEmpty(successMessage)) {
      this.showSuccess(dispatch, successMessage);
    }

    return dispatch(this.defaultSuccessActionCreator(json));
  }

  response400(dispatch, json) {
    if (json.validationErrors && json.validationErrors.length) {
      return dispatch(this.default400ActionCreator(json.validationErrors));
    }
    this.responseError(dispatch, 400, json);
  }

  responseError(dispatch, statusCode, json) {
    var errorMessage = json.errorMessage || json.message || this.defaultErrorMessage();
    dispatch(this.defaultErrorActionCreator()(errorMessage));
    this.showError(dispatch, errorMessage);
  }
}

export const defaultActionManagerRunner = args => new DefaultActionManager(args).run();

export default DefaultActionManager;
